// Google Analytics 4 (GA4) wrapper.
// O ID e publico (visivel no codigo-fonte de qualquer site com GA4) — pode ficar hardcoded.
// O script GA4 e injetado em /public/index.html.

const GA_ID = 'G-16YVZQ8MML';
export const IS_GA_ENABLED = typeof window !== 'undefined';
export { GA_ID };

/**
 * Dispara um evento customizado para GA4.
 * Se o GA nao estiver configurado, silenciosamente nao faz nada (modo defensivo).
 *
 * @param {string} eventName - nome do evento (ex: 'signup_started')
 * @param {object} params - propriedades adicionais (ex: { plan: 'pro', value: 39.90 })
 */
export function trackEvent(eventName, params = {}) {
  if (!IS_GA_ENABLED) return;
  try {
    if (window.gtag) {
      window.gtag('event', eventName, params);
    }
  } catch (e) {
    // nunca quebrar a UI por falha de analytics
    // eslint-disable-next-line no-console
    console.warn('[analytics] trackEvent falhou:', e);
  }
}

/**
 * Dispara page_view manualmente (util para SPAs onde route nao recarrega a pagina).
 */
export function trackPageView(pathname) {
  if (!IS_GA_ENABLED) return;
  try {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: pathname || window.location.pathname,
        page_location: window.location.href,
      });
    }
  } catch (_) { /* noop */ }
}
